(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  const blocks = document.querySelectorAll('.faq-block');
  const navLi = document.querySelectorAll('.items-wrapper .menu-list .list-item');
  window.onscroll = () => {
    let current = '';
    blocks.forEach((block) => {
      const blockTop = block.offsetTop;
      if (pageYOffset >= blockTop - 60) {
        current = block.getAttribute('id');
      }
    });

    navLi.forEach((li) => {
      li.classList.remove('active');
      if (li.classList.contains(current)) {
        li.classList.add('active');
      }
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Intentionally left blank.
  // `localization-form` is defined in assets/custom.js with city-aware logic.

  } catch(e) { console.error(e); }
})();
})();
